module.exports = __webpack_public_path__ + "img/logo.63e15976.png";